import React, { useEffect } from 'react';
import { AlertHeader } from '../components/sales/AlertHeader';
import { HeroSection } from '../components/sales/HeroSection';
import { LeadSection } from '../components/sales/LeadSection';
import { BenefitsSection } from '../components/sales/BenefitsSection';
import { ProductShowcase } from '../components/sales/ProductShowcase';
import { BonusesSection } from '../components/sales/BonusesSection';
import { OfferSection } from '../components/sales/OfferSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { FAQSection } from '../components/sales/FAQSection';
import { StickyFooter } from '../components/sales/StickyFooter';
import { RecentPurchaseToast } from '../components/ui/RecentPurchaseToast';
export function SalesPage() {
  useEffect(() => {
    // Fire Meta Pixel PageView on mount
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 pb-20 md:pb-0 relative" data-id="element-433">
      <AlertHeader data-id="element-434" />
      <HeroSection data-id="element-435" />
      <LeadSection data-id="element-436" />
      <BenefitsSection data-id="element-437" />
      <ProductShowcase data-id="element-438" />
      <BonusesSection data-id="element-439" />
      <OfferSection data-id="element-440" />
      <TestimonialsSection data-id="element-441" />
      <FAQSection data-id="element-442" />

      <footer className="bg-gray-900 text-gray-400 py-8 px-4 text-center text-sm" data-id="element-443">
        <div className="max-w-4xl mx-auto" data-id="element-444">
          <p className="mb-4" data-id="element-445">
            Este producto no sustituye el parecer de un médico profesional.
            Siempre consulte a un médico para tratar asuntos de salud.
          </p>
          <p data-id="element-446">
            &copy; {new Date().getFullYear()} Protocolo de Limpieza Glicémica.
            Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <StickyFooter data-id="element-447" />
      <RecentPurchaseToast data-id="element-448" />
    </div>;
}